import { client } from "@/http/client"

import { IPagingResponse, IRequestParams, IResponse } from "@/types/api"
import { ICountEntityVerificationCatalog, IInformationNotification, INotification, IUpdateReadStatusNotifications } from "@/types/INotification"


export const getNotificationsByCurrentUser = (params: IRequestParams, customerId?: number): Promise<IPagingResponse<INotification>> =>
     client.get("/Notifications", { params: { ...params, customerId } })

export const getNotReadNotificationsByCurrentUser = (countRecord?: number): Promise<IResponse<INotification[]>> =>
     client.get(`/Notifications/not-read?countRecord=${countRecord ?? undefined}`)

export const getCountByAwaitsVerificationStatus = (customerId?: number): Promise<IResponse<ICountEntityVerificationCatalog>> =>
     client.get(`/Notifications/count-by-verification${customerId ? "/" + customerId : ""}`)

export const getNotReadCountNotificationsByCurrentUser = (): Promise<IResponse<number>> =>
     client.get("/Notifications/not-read-count")

export const updateReadStatusForNotifications = (body: IUpdateReadStatusNotifications): Promise<IResponse<boolean>> => 
     client.put("/Notifications/read-status", body) 

export const readAllNotReadNotifications = (): Promise<IResponse<boolean>> => 
     client.put("/Notifications/read-all") 

export const sendInformationNotifications = (body: IInformationNotification):Promise<IResponse<boolean>> =>
     client.post("/Notifications/send/information", body)